import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterComparativoUnidades } from "../../../services/comparativoUnidades"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ComparativoUnidadesInicial } from "../models/comparativoUnidadesModel"
import { ComparativoUnidadesActionsTypes } from "./comparativoUnidadesActions"
import { ComparativoUnidadesContext } from "./ComparativoUnidadesContext"
import { comparativoUnidadesReducer } from "./comparativoUnidadesReducer"

function hoje(): string {
    return new Date().toISOString().slice(0, 10)
}

function primeiroDiaMes(): string {
    const d = new Date()
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`
}

export function ComparativoUnidadesContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(comparativoUnidadesReducer, ComparativoUnidadesInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(
        async (dataInicio: string, dataFim: string) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                setErroCarregamento(null)
                const response = await obterComparativoUnidades(autorizacao, dataInicio, dataFim)
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar comparativo")
                } else {
                    dispatch({
                        type: ComparativoUnidadesActionsTypes.CARREGAR,
                        payload: response,
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar comparativo")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    useEffect(() => {
        pesquisar(primeiroDiaMes(), hoje())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ComparativoUnidadesContext.Provider
            value={{ dados, dispatch, erroCarregamento, pesquisar }}
        >
            <Loading />
            {children}
        </ComparativoUnidadesContext.Provider>
    )
}
